module.exports = __webpack_public_path__ + "img/imagen9.2b4fff61.png";